import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { colors } from '../../../styles/colors';
const DEBOUNCE_MS = 300;
export const PlayerSearchBar = ({ value, onChange, placeholder = 'Поиск по имени, нику, телефону, Telegram...', }) => {
    const timerRef = useRef(null);
    const [localValue, setLocalValue] = useState(value);
    // Sync local value when parent resets (e.g., clear from outside)
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    const handleInputChange = useCallback((e) => {
        const raw = e.target.value;
        setLocalValue(raw);
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            onChange(raw);
        }, DEBOUNCE_MS);
    }, [onChange]);
    const handleClear = useCallback(() => {
        setLocalValue('');
        if (timerRef.current !== null) {
            clearTimeout(timerRef.current);
        }
        onChange('');
    }, [onChange]);
    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (timerRef.current !== null) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    return (_jsxs(Box, Object.assign({ sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: colors.surfaceVariant,
            border: `1px solid ${colors.cardBorder}`,
            borderRadius: '10px',
            padding: '4px 12px',
            gap: '8px',
            transition: 'border-color 0.15s',
            '&:focus-within': {
                borderColor: colors.primary,
            },
        } }, { children: [_jsx(SearchIcon, { sx: { color: colors.textHint, fontSize: 20, flexShrink: 0 } }), _jsx(InputBase, { value: localValue, onChange: handleInputChange, placeholder: placeholder, fullWidth: true, sx: {
                    color: colors.textPrimary,
                    fontSize: '14px',
                    '& input::placeholder': {
                        color: colors.textHint,
                        opacity: 1,
                    },
                }, inputProps: { 'aria-label': 'поиск игроков' } }), localValue && (_jsx(IconButton, Object.assign({ onClick: handleClear, size: "small", sx: {
                    color: colors.textHint,
                    padding: '2px',
                    flexShrink: 0,
                    '&:hover': { color: colors.textSecondary },
                }, "aria-label": "\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A" }, { children: _jsx(ClearIcon, { sx: { fontSize: 16 } }) })))] })));
};
